module.exports = __webpack_public_path__ + "img/weapon_s_19.png";